module.exports = __webpack_public_path__ + "static/media/white-mail.59a45fc4.svg";